const state = {
    queue: [],
}

const getters = {
}

const mutations = {
    request: (state, request) => {
        if (!request || !request.request_at) {
            return
        }

        let queue = {}
        queue[request.request_at] = true
        state.queue = Object.assign(queue, state.queue)
    },
    response: (state, response) => {
        if (!response || !response.config || !response.config.request_at) {
            return
        }

        let queue = { ...state.queue }
        if (queue[response.config.request_at]) {
            delete queue[response.config.request_at]
            state.queue = { ...queue }
        }
    },
}

const actions = {
    async request (context, request) {
        context.commit('request', request)
    },
    async response (context, response) {
        context.commit('response', response)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

